import { FormControl } from '@angular/forms';
import { Insurant } from '@models/insurant';
import { Product } from '@models/product';
import { CommonValidators } from '../shared/validators/common-validators';
import { OrderState } from './models/order-state.model';
import { InsuredObject } from '@models/insured-object';

export function isValidInsurant(product: Product, insurant: Insurant): boolean {
    if (typeof product.insurantsForm === 'undefined') {
        return false;
    }
    const cfg = product.insurantsForm.insurants.find((insurantCfg) => insurantCfg.category === insurant.category);
    if (typeof cfg === 'undefined') {
        return false;
    }
    if (!new FormControl(insurant.dateOfBirth, CommonValidators.birthday(cfg.minAge, cfg.maxAge)).valid) {
        return false;
    }
    if (cfg.rankIdMandatory && !insurant.insuranceRankId) {
        return false;
    }
    return true;
}

// Section Price request

export function validateStateForPriceRequest(product: Product, state: OrderState): string | null {
    const objectError = validateInsuredObjects(product, state.insuredObjects);
    if (objectError) {
        return objectError;
    }
    return validateInsurants(product, state.insurants);
}

function validateInsuredObjects(product: Product, objects: InsuredObject[]): string | null {
    if (!product.insuredObjectsForm) {
        return null;
    }
    if (!objects || objects.length === 0) {
        return 'No insured objects';
    }
    if (requiresInsuredObjectValue(product)) {
        if (objects.find((object) => !object.value)) {
            return 'All insured objects must have a value';
        }
    }
    return null;
}

function requiresInsuredObjectValue(product: Product): boolean {
    return !!product.insuredObjectsForm.controls.find((control) => control.name === 'value');
}

function validateInsurants(product: Product, insurants: Insurant[]): string | null {
    if (!product.insurantsForm) {
        return null;
    }
    if (!insurants || insurants.length === 0) {
        return 'No insurants';
    }
    return null;
}

// End section
